

function validateOption(el){
  setTimeout(function(){
    var selectItems = [];
    var $el = $(el);
    var $data = JSON.parse($el.parents('[data-validate]').find('.product__data').html());
    var currentVariant = $el.parents('[data-validate]').find('.product-form__variants option[selected="selected"]').val();

    function checkUsersCart() {
      $.getJSON('/cart.js', function(data){
        var cartData = data.items;
        var cartStock = []
        for (var i = 0; i < cartData.length; i++){
          if (cartData[i].id == currentVariant){
            cartStock.push(cartData[i].quantity);
            checkInventory(cartData[i].id, cartStock.length);
          } else {
            if($('.product-form__package-row').length <= 0){
              checkInventory(cartData[i].id, cartStock.length);
            }
          }
        }
      });

      function checkInventory(cartItemID, cartItemQuantity){
        var packageData = $data.variants;
        console.log('check');
        for (var i = 0; i < packageData.length; i++){
          var packageItemInventory = packageData[i].inventory_quantity;
          if (packageData[i].id == cartItemID){
            if( packageItemInventory <= 0 ){
              $el.parents('[data-validate]').find('[href="#option_submit"]').removeClass('product-package--added').attr('disabled', 'disabled').attr('data-package-item-selected', 'false').html('Out of Stock');
            } else {
              if( packageItemInventory <= cartItemQuantity ){
                $el.parents('[data-validate]').find('[href="#option_submit"]').removeClass('product-package--added').attr('disabled', 'disabled').attr('data-package-item-selected', 'false').html('All available stock in cart');
                $('#AddToCart-product-package').attr('disabled', 'disabled');
              } else {
                if( $el.parents('.product-form__package-row').find('[href="#option_submit"]').attr('data-package-item-selected') == 'false' ){
                  if($('.product-form__package-row').length >= 1){
                    $el.parents('.product-form__package-row').find('[href="#option_submit"]').attr('disabled', false).html('Add to Package');
                  } else {
                    $el.parents('[data-validate]').find('[href="#option_submit"]').attr('disabled', false).html('Add to Cart');
                  }
                } else {
                  if($('.product-form__package-row').length >= 1){
                    $el.parents('.product-form__package-row').find('[href="#option_submit"]').attr('disabled', false).html('Selected');
                  } else {
                    $el.parents('[data-validate]').find('[href="#option_submit"]').attr('disabled', false).html('Add to Cart');
                  }
                }
              }
            }
          } else {
            if (packageData[i].id == currentVariant){
              if( packageItemInventory <= 0 ){
                $el.parents('[data-validate]').find('[href="#option_submit"]').removeClass('product-package--added').attr('disabled', 'disabled').attr('data-package-item-selected', 'false').html('Out of Stock');
              }
            }
          }
        }
      }
    };

    checkUsersCart();

    $('.single-option-selector').each(function(){
      if( $(this).val() != null && $(this).parents('.product-package__tools').find('.package_stock_level').text() != 'Out of Stock') {
        selectItems.push(true);
      } else {
        selectItems.push(false);
      }
    });

    Array.prototype.allValuesSame = function() {
      for(var i = 0; i < this.length; i++){
        if(this[i] !== true){
          return false;
        }
      }
      return true;
    }

    if( selectItems.allValuesSame() == true ){
      addPackage();
    } else {
      console.log('no');
      $('.product-package--btn-options').html('Select Package Options');
      $('#AddToCart-product-package').prop('disabled', 'disabled').html('Please select all options');
    }
  }, 150);
}

function addPackage() {
  console.log('yes');
  $('.parent_item').html('<input type="hidden" name="id[]" value="' + parentVariant + '">');
  $('.single-item-option').attr('selected', 'selected');
  $('#AddToCart-product-package').prop('disabled', false).html('Add Package To Cart');
  //$('.product-package--btn-options').html('Create another package');
}

(function($){
  //This function not in use as the gallary template not availabe anymore
  // THESE ARE INITIALISATIONS AND OPTIONS FOR THE PRODUCT TEMPLATE GALLERY ONLY
  /*$('form[action="/cart/add"]').each(function(){
    theme.Product(this);
  });*/

  $('.slider-for').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.slider-nav'
  });

  $('.slider-nav').slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    autoplay: false,
    adaptiveHeight: true
  });

  $('.product-single__size-btn').on('click', function(e){
    e.preventDefault();
    $('.size-guide__wrapper').addClass('size-guide__wrapper--active');
  });

  $('.product-single__size-btn-close').on('click', function(e){
    e.preventDefault();
    $('.size-guide__wrapper').removeClass('size-guide__wrapper--active');
  });

  $('.size-guide__wrapper').on('click', function(e){
    e.preventDefault();

    if (e.target == this) {
      $('.size-guide__wrapper').removeClass('size-guide__wrapper--active');
    }
  });

  /* SLICK SLIDER SWITH BASED ON VARIANTS */
  var packageSize = $('.product-form__package-row').length;
  if( packageSize > 0 ){
    $(window).on('load', function(){
      $('.product-form__package-row').each(function(index){
        var i = index;
        slickIndex[i] = [];
        $(this).find('.product-single__photos img').each(function(){
          var thisID = $(this).data('id');
          slickIndex[i].push(thisID);
        });
      });
    });

    $(document).on('switchImageVariant', function(e){
      var eIndex = e.slickVarPack;
      var $targetEl = $(e.target.activeElement).parents('.product-form__package-row').find('.slider-for');
      $targetEl.slick('slickGoTo', eIndex);
    });


    var slideObj    = $('.slider-for').slick('getSlick');
    var slideLength = slideObj.$slides.length;

    if( slideLength <= 1 ){
      $('.product-single__thumbnails').addClass('visually-hidden');
      $('.product-single__photos-wrapper').addClass('no-thumbs');
    } else {
      $('.product-single__thumbnails').removeClass('visually-hidden');
      $('.product-single__photos-wrapper').removeClass('no-thumbs');
    }

    $('.lightbox-gallery').featherlightGallery({
      previousIcon: '&#xe904;',
      nextIcon: '&#xe901;',
      galleryFadeIn: 100,
      galleryFadeOut: 300
    });

    $('.product-single__zoom').on('click', function(e){
      e.preventDefault();
      $('.slick-active').trigger('click');
    });

    /* Check if Package Page and do package video and button stuff */

    if( packageSize > 0 ){
      $('.product-package__desc--readmore').on('click', function(e){
        e.preventDefault();

        $(this)
          .hide()
          .prev('.product-package__desc').addClass('product-package__desc--mobile-show');
      });

      $('.product-package--btn-options').on('click', function(){
        $('html, body').animate({ scrollTop: $('.product-package__body').offset().top - 75 }, 350);
        $('a[href="#option_submit"]')
        .removeClass('product-package--added')
        .attr('data-package-item-selected', 'false')
        .text('Add to Package')
        .each(function(){
          validateOption(this);
        });
      });

      $('.product-form__package-select').on('change', function(){
        validateOption(this);
      });

      $(window).on('load', function(){
        $('.product-form__package-select').each(function(){
          validateOption(this);
        });
      });

      var v = 0;
      $('.product-form__package-row').each(function() {
        if ($(this).find('.single-option-selector').length < 1 && $(this).find('.product-package__tools p').text() != 'Out of Stock') {
          v++
        }
      });

      console.log(packageSize);
      console.log(v);

      if (v == packageSize) {
        addPackage();
      }
    } else {
      $('.single-option-selector').on('change', function(){
        var $this = $(this);
        setTimeout(function(){
          validateOption($this);
        },200);
      });

      if( $('.single-option-selector').length > 0 ){
        validateOption($('.single-option-selector'));
      }
    }
  }

  $('form[action="/cart/add"]').each(function(){
    var noSwatches = $(this).find('.swatch').length;
    if( noSwatches > 1 ){
      $(this).find('.swatches').addClass('swatches--active');
    };
  });

  $('[href="#readmore"]').on('click', function(e){
    e.preventDefault();
    $('html, body').animate({ scrollTop: $('.product-single__tabs').offset().top - 100 }, 300);
    $('[data-tab-header="details"]').trigger('click');
  });

  $('[href="#reviews"]').on('click', function(e){
    e.preventDefault();
    $('html, body').animate({ scrollTop: $('.product-single__tabs').offset().top - 100 }, 300);
    $('[data-tab-header="reviews"]').trigger('click');
  });

  
  $('[href="#playYoutubeVideo"]').on('click', function(){
    $('[data-tab-header="video"]').trigger('click');
  });

  var $tabButton = $('.product-single__tabs-button');

  $tabButton.on('click', function(){
    var dataTab = $(this).attr('data-tab-header');
    $('[data-tab-header]').removeClass('product-single__tabs-button--active');
    $(this).addClass('product-single__tabs-button--active');
    $('[data-tab-content]').removeClass('product-single__tabs-text--active');
    $('[data-tab-content='+dataTab+']').addClass('product-single__tabs-text--active');
  });

  // THIS IS A HELPER FOR OPTIONS SELECTION
  $('.single-option-selector').each(function(){
    $(this).on('change', function(e){
      // This will trigger every time someone changes a select box
      // Selected variant is set to data-variant, this is controlled in theme.js.liquid
      // Helpers
      var selectorID    = $(this).prop('id')
      ,   selectorClass = $(this).prop('class')
      ,   selectorData  = $(this).data('index')
      ,   selectorVal   = $(this).val();
    });
  });

 /* $("a[href='/apps/iwish']").click(function(e) {
    if(typeof(Storage) !== "undefined") {
      e.preventDefault();
      iWishPost('/apps/iwish',{iwishlist:JSON.stringify(iWishlistmain),cId:iwish_cid});
    }
  });

  $(".iWishAdd").click(function() {
    var iWishvId = $(this).parents('form').find("[name='id']").val();
    iwish_add($(this), iWishvId);
    return false;
  });
*/
  $('.single-option-selector').each(function(){
    var optionLength = $(this).find('option').length;
    if(optionLength <= 1){
      $(this).hide();
    }
  });

  $(window).on('load', function(){
    $('.recommendation-slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      autoplay: false,
      infinite: true,
      pauseOnHover: false,
      arrows: true,
      responsive: [
      {
        breakpoint: 1280,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 1
        }
      }
      ]
    });

    if( $('.recommendation-slider .slick-slide').length <= 0 ){
      $('.recommendations').hide();
    }
  });  
  
    $(window).on('load', function(){
    $('.matching-colors-slider').slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      autoplay: false,
      infinite: true,
      pauseOnHover: false,
      arrows: true,
      responsive: [
      {
        breakpoint: 1280,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          dots: true,
          arrows: false,
          slidesToShow: 1
        }
      }
      ]
    });

    if( $('.matching-colors-slider .slick-slide').length <= 0 ){
      $('.matchedproducts').hide();
    }
  });  
  
})(jQuery);


//Calculate the free postage on page via ajax method




function postagecheck() {
    //delay the function so the items have a moment to go in
    $(this).delay(2000).queue(function() {
      //grab the cart.js json and output
      jQuery.getJSON('/cart.js', function(cart) {
          //console.log(cart.total_price);
          //build postage messages up
        if (cart.total_price == 0) {    
              var fpfree = 4000 - cart.total_price;
                var fp = fpfree / 100;
                var fpmessage = 'Spend £'+fp.toFixed(2)+' To Get Free UK Delivery';
                //console.log(fpmessage);  
                $(".product-single__delivery--text").html(fpmessage);
      }
        else if (cart.total_price < 4000) {
                var fpfree = 4000 - cart.total_price;
                var fp = fpfree / 100;
                var fpmessage = 'Spend £'+fp.toFixed(2)+' More To Get Free UK Delivery';
                //console.log(fpmessage);  
                $(".product-single__delivery--text").html(fpmessage);
      } else { 
          //console.log('You are now eligible for free UK delivery');
                $(".product-single__delivery--text").html("You are now eligible for free UK delivery");
      }
      });
    //run the function.  
    $(this).dequeue();
  });    
};
  
// If buy button pressed run function
$( "#AddToCart-product-template" ).click(function() {
  //console.log('add to cart button pressed');
    postagecheck();
  $( ".upsell-select-option_button" ).delay(1000).removeClass( "upsell_btn_color" )
  $( ".product-form__cart-variantUpsell" ).delay(1000).removeClass( "upsell_btn_color" )
});

// If ajax cart modified run function
$(document).on('DOMNodeInserted', function(e) {  
  
  $( ".cart-ajax__remove" ).click(function() {
    //console.log('remove button pressed');
    postagecheck();
  });
  
  $( ".cart-ajax__quantity-ico" ).click(function() {
    //console.log('quantity changed');
    postagecheck();
  });
  
}); 

//Grab currently selected variant strip in stock wording and pass into purchased popup

value = ($.trim($(".product-form__input").first().children("option:selected").text()));
var value = value.replace('– In Stock','');
document.getElementsByClassName('product-purchased-variant')[0].innerHTML = value;

$(".product-form__input").change(function(){
  value = ($.trim($(".product-form__input").first().children("option:selected").text()));
  console.log (value);
  var value = value.replace('– In Stock','');
  document.getElementsByClassName('product-purchased-variant')[0].innerHTML = value;
});


// Open questions

function openQuestions() {
  //console.log ('questions button pressed'); 
  $('.product-single__tabs-button').removeClass('product-single__tabs-button--active');
   $('.product-single__tabs-button').each(function (index) {
    if ($(this).attr('data-tab-header') == 'questions') { $(this).addClass('product-single__tabs-button--active'); }
   });
   $('.product-single__tabs-text').removeClass('product-single__tabs-text--active');
   $('.product-single__tabs-text').each(function (index) {
    if ($(this).attr('data-tab-content') == 'questions') { $(this).addClass('product-single__tabs-text--active'); }
   });

   setTimeout(function () { $('.spr-summary-actions-newreview').trigger('onclick') }, 400); 

   $('html,body').animate({
    scrollTop: $('.product-single__tabs-header').offset().top
   });
}

// Open and close feature text

function openToolTipText() {
  var td = $(event.target).parent();
  td.find('.product-compare-tooltiptext').fadeIn().css("display","inline-block"); 
}

function closeToolTipText() {
  var close = $(event.target).parent();
  close.fadeOut();
}

// Due date JS

// If product has tag in following format 'sku "55667-7" discontinued' then if stock level is 0 post out option name - discontinued  
// Else If product has tag in the following format 'sku "56567-2" due 20/05/2019' then if stock level is 0 and date is newer than current date then update the text on the dropdown to say Due 20th May etc
  
$(document).ready( function () {

  $('.single-option-selector').attr('disabled', false);
  
  //console.log ('due date updater running');

  var currentDate = new Date();
  
  $( ".option-product" ).each(function( i ) {
    
    var stockamount = $(this).attr("data-stockamount");
    var duedate = $(this).attr("data-duedate");
    
    if (stockamount == 0 && duedate == "discontinued//" ) {
      
      //console.log ('discontinued product');
      
      var varianttype = $(this).attr("data-varianttype")
      
      if (varianttype == "single-novariant") {
        var introText = "Out of Stock - ";
      } else {
        var introText = "";
      }
      
      var dueSoonValue = introText + ("Discontinued")
      
      var text = $(this).html();
      $(this).html(text.replace('Out of Stock',dueSoonValue ));
            
    } else if (stockamount == 0 && duedate != "//" ) {
      
      //console.log ('started running');
      
      var productDate = new Date(duedate);

      const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ];
      const d = new Date(duedate);

      var productDay = productDate.getDate();
      
      if (productDay == 1 || productDay == 21 || productDay == 31) {var dateExtension = "st";}
      if (productDay == 4 || productDay == 5 || productDay == 6 || productDay == 7 || productDay == 8 || productDay == 9 || productDay == 10 || productDay == 11 || productDay == 12 || productDay == 13 || productDay == 14 || productDay == 15 || productDay == 16 || productDay == 17 || productDay == 18 || productDay == 19 || productDay == 20 || productDay == 24 || productDay == 25 || productDay == 26 || productDay == 27 || productDay == 28 || productDay == 29 || productDay == 30) {var dateExtension = "th";}
      if (productDay == 2 || productDay == 22) {var dateExtension = "nd";}
      if (productDay == 3 || productDay == 23) {var dateExtension = "rd";}
      
      var varianttype = $(this).attr("data-varianttype")
      
      if (varianttype == "single-novariant") {
        var introText = "Out of Stock - ";
      } else {
        var introText = "";
      }
      
      var dueSoonValue = introText + ("Due ") + productDay + dateExtension + (" ") + monthNames[d.getMonth()];

      //console.log ("Due date is " + duedate);

      if (productDate.getTime() > currentDate.getTime()) {
        //console.log ("due date is newer");
        var text = $(this).html();
        $(this).html(text.replace('Out of Stock',dueSoonValue )); 
      } else {
        //console.log ("due date is older");
      }
      
    };
  });
  
});